import { NgModule } from '@angular/core';
import { BatchExtraAttachmentsModule } from './batches/batch-extra-attachments/batch-extra-attachments.module';
import { NotificationsModule } from './notifications/notifications.module';
import { QpInvitationsModule } from './qp-invitations/qp-invitations.module';

const PATH_COMMON_MODULES = [BatchExtraAttachmentsModule, NotificationsModule, QpInvitationsModule];

@NgModule({
  declarations: [],
  imports: [PATH_COMMON_MODULES],
  exports: [PATH_COMMON_MODULES]
})
export class PathCommonModule {}
